import { ClientEvents } from 'common/events/ClientEvents';
import React from 'react';
import { useTracker } from 'src/shared/hooks/useTracker';
import { Colors } from 'web-common/src/shared/styles';
import { ScrollButtonProps } from '../types';
import { ARROW_SIZE } from './consts';
import { ArrowLeft, ArrowRight, ButtonContainer, Container, ScrollButton } from './styles';

export const ScrollButtons: React.FC<ScrollButtonProps> = ({
  className,
  scrollRight,
  scrollLeft,
  numElementsLeft,
  numElementsRight,
  hasBackgroundColor,
  elementName,
}): JSX.Element => {
  const tracker = useTracker();

  const getScrollButtonClickHandler = (direction: 'left' | 'right') => () => {
    tracker.track(ClientEvents.SEGMENT_ARROW_CLICK, { direction, elementName });
    direction === 'left' ? scrollLeft() : scrollRight();
  };

  const arrowColor = hasBackgroundColor ? Colors.WHITE : Colors.RADISH;
  return (
    <Container className={className}>
      <ButtonContainer onClick={getScrollButtonClickHandler('right')} disabled={numElementsRight === 0}>
        <ScrollButton hasBackgroundColor={hasBackgroundColor} />
        <ArrowRight color={arrowColor} width={ARROW_SIZE} height={ARROW_SIZE} />
      </ButtonContainer>

      <ButtonContainer onClick={getScrollButtonClickHandler('left')} disabled={numElementsLeft === 0}>
        <ScrollButton hasBackgroundColor={hasBackgroundColor} />
        <ArrowLeft color={arrowColor} width={ARROW_SIZE} height={ARROW_SIZE} />
      </ButtonContainer>
    </Container>
  );
};
